var render = function (_h,_vm) {var _c=_vm._c;return _c('button',_vm._g({class:_vm.data.staticClass,attrs:{"type":"button"}},_vm.listeners),[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }